
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const SocialProof = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2.2 }}
      className="text-center"
    >
      <div className="flex items-center justify-center gap-2 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
        ))}
        <span className="text-sm text-muted-foreground ml-2">4.9/5 from 200+ users</span>
      </div>
      <p className="text-muted-foreground">
        Join thousands of businesses already using doozy to grow their digital presence
      </p>
    </motion.div>
  );
};

export default SocialProof;
